import React, { Component } from 'react'
import { routes } from '../content/routes'

class GoToTokenPageCTA extends Component {
  constructor(props) {
    super(props)
    let tokenPage = routes.filter(r => r.isTokenPage)[0]
    this.state = {
      tokenPage
    }
  }
  render() {
    return (
      <div className="footer-signup-container" style={{ paddingTop: '.5em' }}>
        <a
          className="header-button"
          href="https://tokenfoundry.com/projects/foam"
          target="_blank"
          rel="noopener noreferrer"
        >
          <strong>PURCHASE FOAM TOKENS</strong> &#10132;
        </a>
      </div>
    )
  }
}

export default GoToTokenPageCTA



// WEBPACK FOOTER //
// ./src/Components/GoToTokenPageCTA.js